import { IconTextPromptOutline18 as PromptIcon } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../../types"
import { iconClassName } from "../../constants"

export const promptCommand: SlashCommandDefinition = {
	key: "prompt",
	title: "Prompt",
	icon: <PromptIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertPrompt().run()
	},
	group: "blocks",
	aliases: ["prompt", "ai prompt", "copy prompt", "cursor"],
}
